import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-concepto-plantilla',
  templateUrl: './add-concepto-plantilla.component.html',
  styleUrls: ['./add-concepto-plantilla.component.css']
})
export class AddConceptoPlantillaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
